import React from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";

import DashboardIcon from "@mui/icons-material/Dashboard";
import LanIcon from "@mui/icons-material/Lan";
import TagIcon from "@mui/icons-material/Tag";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import RememberMeOutlinedIcon from "@mui/icons-material/RememberMeOutlined";
import ApprovalIcon from "@mui/icons-material/Approval";
import CampaignIcon from "@mui/icons-material/Campaign";
import CodeIcon from "@mui/icons-material/Code";
import SpokeIcon from "@mui/icons-material/Spoke";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import WebIcon from "@mui/icons-material/Web";
import WidgetsIcon from "@mui/icons-material/Widgets";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ForkRightIcon from "@mui/icons-material/ForkRight";
import SpeedIcon from "@mui/icons-material/Speed";
import ShowChart from "@mui/icons-material/ShowChart";
import TableChartIcon from "@mui/icons-material/TableChart";
import PublicIcon from "@mui/icons-material/Public";
const menus = [
  {
    label: "Home",
    type: "section",
    key: "home",
    children: [
      {
        uri: "/home/dashboard",
        label: "Dashboard",
        type: "nav-item",
        icon: <DashboardIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/home/reporting", //reporting
        label: "Reporting",
        type: "nav-item",
        icon: <QueryStatsIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: "/home/crm",
      //   label: "CRM",
      //   type: "nav-item",
      //   icon: <LanIcon sx={{ fontSize: 20 }} />,
      // },
    ],
  },

  {
    label: "Consent Management",
    type: "section",
    key: "consent_mgmt",
    children: [
      {
        uri: "/consent/openrequest",
        label: "Open Requests",
        type: "nav-item",
        icon: <TagIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/consent/requesthistory",
        label: "Request History",
        type: "nav-item",
        icon: <AllInboxIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "Audience Management",
    type: "section",
    key: "audience_mgmt",
    children: [
      // {
      //   uri: "/targeting/createaudience",
      //   label: "Create an Audience",
      //   type: "nav-item",
      //   icon: <WidgetsOutlinedIcon sx={{ fontSize: 20 }} />,
      //   suburls: ["/targeting/editaudiencesegment/"],
      // },
      {
        uri: "/audience/geointel",
        label: "GeoIntel",
        type: "nav-item",
        icon: <PublicIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  {
    label: "Publisher Management",
    type: "section",
    key: "publisher_mgmt",
    children: [
      {
        uri: "/publisher/managepublishers",
        label: "Publishers",
        type: "nav-item",
        icon: <RememberMeOutlinedIcon sx={{ fontSize: 20 }} />,
        suburls: ["/publisher/createpublisher", "/publisher/editpublisher/"],
      },
      {
        uri: "/targeting/supplyanalysis",
        label: "Supply Analysis",
        type: "nav-item",
        icon: <AnalyticsIcon sx={{ fontSize: 20 }} />,
        suburls: [
          "/targeting/createsupplyanalysis",
          "/targeting/editsupplyanalysis/",
        ],
      },
      {
        uri: "/publisher/supplydeals",
        label: "Supply Deals",
        type: "nav-item",
        icon: <BusinessCenterIcon sx={{ fontSize: 20 }} />,
        suburls: ["/publisher/createsupplydeal", "/publisher/editsupplydeal/"],
      },

      {
        uri: "/publisher/responsesample",
        label: "Request Samples",
        type: "nav-item",
        icon: <ForkRightIcon sx={{ fontSize: 20 }} />,
        //disabled: true,
      },
      {
        uri: "/publisher/analyticsdashboard",
        label: "Analytics Dashboard",
        type: "nav-item",
        icon: <TableChartIcon sx={{ fontSize: 20 }} />,
        suburls: ["/publisher/analyticsdashboard/"],
        //disabled: true,
      },
      {
        uri: "/publisher/reporting",
        label: "Reporting",
        type: "nav-item",
        icon: <QueryStatsIcon sx={{ fontSize: 20 }} />,
        // suburls: ["/publisher/analyticsdashboard/"],
        //disabled: true,
      },
    ],
  },

  //Bidder Management
  {
    label: "Bidder Management",
    type: "section",
    key: "bidder_mgmt",
    children: [
      {
        uri: "/bidder/managedemandpartners",
        label: "Demand Partners",
        type: "nav-item",
        icon: <SpokeIcon sx={{ fontSize: 20 }} />,
        suburls: ["/bidder/createdemandpartner", "/bidder/editdemandpartner/"],
        //disabled: true,
      },
      {
        uri: "/bidder/manageprivatemarketplace", ///targeting/privatemarketplace
        label: "Private Market Place",
        type: "nav-item",
        icon: <ApprovalIcon sx={{ fontSize: 20 }} />,
        suburls: [
          "/bidder/createprivatemarketplace",
          "/bidder/editprivatemarketplace/",
        ],
      },

      {
        uri: "/bidder/responsesample",
        label: "Request Samples",
        type: "nav-item",
        icon: <ForkRightIcon sx={{ fontSize: 20 }} />,
        //disabled: true,
      },
      {
        uri: "/bidder/analyticsdashboard",
        label: "Analytics Dashboard",
        type: "nav-item",
        icon: <TableChartIcon sx={{ fontSize: 20 }} />,
        suburls: ["/bidder/analyticsdashboard/"],
        //disabled: true,
      },
      {
        uri: "/bidder/supplydashboard",
        label: "Supply Dashboard",
        type: "nav-item",
        icon: <TableChartIcon sx={{ fontSize: 20 }} />,
        suburls: ["/bidder/supplydashboard/"],
        //disabled: true,
      },
      {
        uri: "/bidder/reporting",
        label: "Reporting",
        type: "nav-item",
        icon: <QueryStatsIcon sx={{ fontSize: 20 }} />,
        // suburls: ["/bidder/supplydashboard/"],
        //disabled: true,
      },
    ],
  },

  {
    label: "Campaign Management",
    type: "section",
    key: "campaign_mgmt",
    children: [
      {
        uri: "/advertiser/manageadvertisers",
        label: "Advertisers",
        type: "nav-item",
        icon: <CampaignIcon sx={{ fontSize: 20 }} />,
        suburls: [
          "/advertiser/createadvertiser",
          "/advertiser/editadvertiser/",
        ],
      },
      {
        uri: "/advertiser/audiencepixels",
        label: "Audience Pixels",
        type: "nav-item",
        icon: <CodeIcon sx={{ fontSize: 20 }} />,
        suburls: [
          "/advertiser/createaudiencepixels",
          "/advertiser/editaudiencepixels/",
        ],
      },
      {
        uri: "/targeting/campaigns",
        label: "Campaigns",
        type: "nav-item",
        icon: <CampaignIcon sx={{ fontSize: 20 }} />,
        suburls: ["/targeting/createcampaign", "/targeting/editcampaign/"],
      },
      {
        uri: "/targeting/targetinggroups",
        label: "Targeting Groups",
        type: "nav-item",
        icon: <GroupWorkIcon sx={{ fontSize: 20 }} />,
        suburls: ["/targeting/createtgroup", "/targeting/edittgroup/"],
      },
      {
        uri: "/advertiser/analyticsdashboard",
        label: "Analytics Dashboard",
        type: "nav-item",
        icon: <TableChartIcon sx={{ fontSize: 20 }} />,
        suburls: ["/advertiser/analyticsdashboard/"],
        //disabled: true,
      },
      {
        uri: "/advertiser/supplydashboard",
        label: "Supply Dashboard",
        type: "nav-item",
        icon: <TableChartIcon sx={{ fontSize: 20 }} />,
        suburls: ["/advertiser/supplydashboard/"],
        //disabled: true,
      },
      {
        uri: "/advertiser/reporting",
        label: "Reporting",
        type: "nav-item",
        icon: <QueryStatsIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  // // Reports
  // {
  //   label: "Reports",
  //   type: "section",
  //   key: "report",
  //   children: [
  //     {
  //       uri: "/report/analyticsdashboard",
  //       label: "Analytics Dashboard",
  //       type: "nav-item",
  //       icon: <SpeedIcon sx={{ fontSize: 20 }} />,
  //       //suburls: ["/bidder/createdemandpartner", "/bidder/editdemandpartner/"],
  //       //disabled: true,
  //     },
  //     // {
  //     //   uri: "/report/supplydashboard", ///targeting/privatemarketplace
  //     //   label: "Supply Dashboard",
  //     //   type: "nav-item",
  //     //   icon: <ShowChart sx={{ fontSize: 20 }} />,
  //     // },
  //   ],
  // },
  {
    label: "Admin",
    type: "section",
    key: "admin_mgmt",
    children: [
      {
        uri: "/system/managecompanies",
        label: "Organizations",
        type: "nav-item",
        icon: <BusinessOutlinedIcon sx={{ fontSize: 20 }} />,
        suburls: ["/system/createcompany", "/system/editcompany/"],
      },
      // {
      //   uri: "/system/managecompanies",
      //   label: "Manage Companies",
      //   type: "nav-item",
      //   icon: <AllInboxIcon sx={{ fontSize: 20 }} />,
      // },
      {
        uri: "/system/manageaccounts",
        label: "Accounts",
        type: "nav-item",
        icon: <PeopleOutlineOutlinedIcon sx={{ fontSize: 20 }} />,
        suburls: ["/system/createaccount", "/system/editaccount/"],
      },
      // {
      //   uri: "/system/manageaccounts",
      //   label: "Manage Accounts",
      //   type: "nav-item",
      //   icon: <AllInboxIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "/system/createpublisher",
      //   label: "Create Publisher",
      //   type: "nav-item",
      //   icon: <TagIcon sx={{ fontSize: 20 }} />,
      // },
      // {
      //   uri: "/system/managepublishers",
      //   label: "Manage Publishers",
      //   type: "nav-item",
      //   icon: <AllInboxIcon sx={{ fontSize: 20 }} />,
      // },

      {
        uri: "/system/manageusers",
        label: "Users",
        type: "nav-item",
        icon: <PersonOutlinedIcon sx={{ fontSize: 20 }} />,
        suburls: ["/system/createuser", "/system/edituser/"],
      },
      {
        uri: "/system/manageroles",
        label: "Roles",
        type: "nav-item",
        icon: <WidgetsIcon sx={{ fontSize: 20 }} />,
        suburls: ["/system/createrole", "/system/editrole/"],
      },
      {
        uri: "/system/managethemes",
        label: "Themes",
        type: "nav-item",
        icon: <WebIcon sx={{ fontSize: 20 }} />,
        suburls: ["/system/createtheme", "/system/edittheme/"],
      },
      {
        uri: "/system/managedashboarduserroles",
        label: "Dashboard User Roles",
        type: "nav-item",
        icon: <WidgetsIcon sx={{ fontSize: 20 }} />,
        suburls: [
          "/system/createdashboarduserrole",
          "/system/editdashboarduserrole/",
        ],
      },
      // {
      //   uri: "/system/manageusers",
      //   label: "Manage Users",
      //   type: "nav-item",
      //   icon: <AllInboxIcon sx={{ fontSize: 20 }} />,
      // },
    ],
  },
  {
    label: "Payments",
    type: "section",
    key: "payments",
    children: [
      {
        uri: "/payments/addpayment",
        label: "Make a Payment",
        type: "nav-item",
        icon: <CreditCardIcon sx={{ fontSize: 20 }} />,
        //suburls: ["/payments/addpayment", "/system/editcompany/"],
      },
      {
        uri: "/payments/paymenthistory",
        label: "Payment History",
        type: "nav-item",
        icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
        //suburls: ["/system/createaccount", "/system/editaccount/"],
      },
    ],
  },
];

export default menus;
